import { render, staticRenderFns } from "./IndicatorScore.vue?vue&type=template&id=598d9f13&scoped=true&"
import script from "./IndicatorScore.vue?vue&type=script&lang=js&"
export * from "./IndicatorScore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "598d9f13",
  null
  
)

export default component.exports